$('.product-quantity .btnqty').on('click', async function(){

          var qty = parseInt($(this).parent('.product-quantity').find('.cart__qty-input').val());
          if($(this).hasClass('qtyplus')) {
            qty++;
          }else {
            if(qty > 0) {
              qty--;
            }
          }
          qty = (isNaN(qty))?1:qty;
          $(this).parent('.product-quantity').find('.cart__qty-input').val(qty);
           var newdatakey = `${parseInt($(this).parent('.product-quantity').find('.cart__qty-input').data('key'))}`;

            const req = await fetch('/cart/change.json', {
				method: "POST",
				headers: {
					"Content-type": "application/json"
				},
				body: JSON.stringify({
                'id': newdatakey,
                'quantity': qty
             })
			})
       
           const res = await req.json();
            console.log(res);
             const cartReq = await fetch('/cart?view=ajaxcart') 
	         const cartRes = await cartReq.text();
           if(window.location.pathname == '/cart') {
				$("#cartgift").html(cartRes);
             Getcart();
			}
             
  
        }); 
  
 async function Getcart() {
        let cartItems = '';
        const req = await fetch('/cart.json', {
		 	method: "GET",
		 	headers: {
		 		"Content-type": "application/json"
			}
         });  
               const rese = await req.json();
         document.getElementById("CartCount1").innerHTML = `<span data-cart-count="" class="count-cart">${rese.item_count}</span>`;
        document.getElementById("CartCount").innerHTML = `<span data-cart-count="" class="count-cart">${rese.item_count}</span>`;
            const cartReq = await fetch('/cart?view=ajaxcart')
	         const cartRes = await cartReq.text();
            
 }  
  
  